import { Component, OnInit, Input, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { HeaderService, CatalogService, AuthenticationService, UtilsService, ListsService } from 'src/app/_services';
import { Router, ActivatedRoute } from '@angular/router';
import { User, FileProduct, Product, Category } from 'src/app/_models';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { BasketService } from 'src/app/_services/basket.service';
import { Location } from '@angular/common';
import { ProductExtendedInfoModalComponent } from '../product-extended-info-modal/product-extended-info-modal.component';
import { environment } from 'src/environments/environment.prod';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductFormatOptionsModalComponent } from '../product-format-options-modal/product-format-options-modal.component';

declare const $ : any ;

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {

  currentUser : User

  @Input()  itemId : string = '';
  @Input()  inModal : boolean = false;

  public fileProduct : FileProduct;
  public product : Product;
  public promo : Category;

  @ViewChild(ProductFormatOptionsModalComponent) formatOptionsModal: ProductFormatOptionsModalComponent; 
  @ViewChild(ProductExtendedInfoModalComponent) extendedInfoModal: ProductExtendedInfoModalComponent;


   constructor(
    private auth : AuthenticationService,
    public router : Router,
    public route : ActivatedRoute,
    public location : Location,
    public catalog : CatalogService,
    public translate : TranslateService,
    public dom : DomSanitizer,
    public apps : ApplicationStateService,
    public header : HeaderService,
    public basket : BasketService,
    public utils : UtilsService,
    public listss : ListsService,
    private spinner: NgxSpinnerService,
    private titles : Title
  ) { 
    header.setHeader(false,false,true,true);
  
 
    this.route.params.subscribe( result => {
      this.itemId = result.itemId;
      this.product = this.router.getCurrentNavigation().extras.state as Product;
      this.loadData();
    });

    this.catalog.currentCategory = null;
    this.auth.currentUser.subscribe(
      currentUser  => {
        this.currentUser = currentUser;
      });
  }

  ngOnInit() {
    this.fileProduct = null;
  }

  ngOnChanges() {
    if ( this.itemId ){
      this.loadData();
    } // else {
    //   this.router.navigate(['/error404'])
    // }
    this.header.scrollTop();
   
  }

  loadData() {
    this.fileProduct = null;
    if ( this.itemId && this.itemId != ''){
      setTimeout(() => {
        this.spinner.show();
      }, environment.READY_TIMEOUT);


      this.catalog.getProduct(this.itemId, this.translate.currentLang).subscribe( result =>{
        this.fileProduct  = result;

        // Si hi ha producte a l'historic (venim del llistat), passa la informació del llistat.
        if (this.product != null) {
          this.fileProduct.product = this.product;

          // si venint del llistat el producte esta en promoció, obté la promoció
          if (this.fileProduct.product.inPromo){
            this.catalog.getTree(this.auth.isLogedUser).subscribe(tree =>{
                this.promo = tree.getCategory(this.fileProduct.product.promo_id);
            });
          }
        }

        this.translate.get( 'CATALOG_TITLE', {
          title : this.fileProduct.product.getText(this.translate.currentLang)
        }).subscribe(translation =>{
          this.titles.setTitle(translation);
        });


        setTimeout(() => {
          var $easyzoom = $('.easyzoom').easyZoom();          
          var api = $easyzoom.data('easyZoom');
          this.spinner.hide();
        }, environment.READY_TIMEOUT);
      }, error =>{
        setTimeout(() => {
          this.spinner.hide();        
        }, environment.READY_TIMEOUT);
      });
    }  
  }

  onShowExtendedInfo(){   
    $('#modal-extended-info-product').modal('show');
    this.extendedInfoModal.fileProduct = this.fileProduct;
    this.extendedInfoModal.loadData()
  }


  goBack(){
    this.location.back();
  }

}
